export default "__VITE_ASSET__DL$lUVXW__"